/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2021.

!Changelog

2021
	12-03-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_pdf.onready();

	
!Wishlist

	none
	
*/
  
var specific_date = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	// none

	this.onready = function() {

		setInterval(function() {

	    	specific_date.update();

    	}, 0.5 * 3600 * 1000);

	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	this.update = function() {

		var dateObj 	= new Date();
	    
	    var month 		= dateObj.getMonth() + 1;
	    var day 		= String(dateObj.getDate()).padStart(2, '0');
	    var year 		= dateObj.getFullYear();
	    
	    var livedate 	= day + '-'+ month + '-' + year;

    	$('.js-date-live').html(livedate);

	};

}).apply(specific_date); 